import React from 'react';
import { createRoot } from 'react-dom/client';
import './App.css';

import App from './App';
import * as Sentry from '@sentry/react';

// Render your React component instead
const root = createRoot(document.getElementById('root') as Element);

async function enableMocking() {
  if (process.env.NODE_ENV !== 'development') {
    return;
  }
  const { worker } = require('./service/mocks/browser');
  return worker.start();
}

// enableMocking().then(() => {
//   root.render(<App />);
//   if ((module as any).hot) {
//     (module as any).hot.accept('./App', () => {
//       root.render(<App />);
//     });
//   }
// });

if (process.env.FEATURE_ENV !== 'local') {
  Sentry.init({
    environment: process.env.FEATURE_ENV,
    dsn: 'https://e6eaa30f56eef6e3ef050267952a2b1f@o4508816411721728.ingest.us.sentry.io/4508816413884416',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['https://dev.jenmusic.tech/api', 'https://staging.jenmusic.tech/api', 'https://app.jenmusic.ai/api'],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

root.render(<App />);
if ((module as any).hot) {
  (module as any).hot.accept('./App', () => {
    root.render(<App />);
  });
}
